import { defineComponent as g, useAttrs as x, computed as i, ref as E, createBlock as u, openBlock as t, unref as m, mergeProps as p, withCtx as d, resolveDynamicComponent as N, toHandlers as V, createElementBlock as l, createCommentVNode as a, createElementVNode as v, normalizeClass as r, renderSlot as o } from "vue";
import { RevButtonBase as z } from "@ds/components/ButtonBase";
import { RevListItemBase as D } from "@ds/components/ListItemBase";
import { useTrackedListeners as H } from "../../composables/useTrackedListeners.js";
import { omit as O } from "../../utils/omit.js";
const G = /* @__PURE__ */ g({
  name: "RevListItemInteractive",
  inheritAttrs: !1,
  __name: "ListItemInteractive",
  props: {
    for: { default: void 0 },
    to: {},
    wrapperAttrs: { default: () => ({}) },
    itemsCenter: { type: Boolean, default: !1 }
  },
  setup(n, { expose: h }) {
    const s = n, { listeners: k } = H(s), $ = x(), f = i(() => O($, ["onClick"])), y = i(() => s.for ? "label" : z), c = E(null);
    function C() {
      const e = c.value;
      Array.isArray(e) || e === null || e.$el && e.$el.focus();
    }
    h({ focus: C });
    const A = i(
      () => s.to || f.value?.href
    );
    return (e, P) => (t(), u(m(D), p(n.wrapperAttrs, { "items-center": n.itemsCenter }), {
      default: d(({
        wrapperClassNames: B,
        prefixClassNames: b,
        descriptionClassNames: I,
        labelClassNames: L,
        suffixClassNames: R,
        mainAreaClassNames: w
      }) => [
        (t(), u(N(y.value), p(f.value, {
          ref_key: "item",
          ref: c,
          class: ["focus-visible-outline-inset-hi cursor-pointer rounded-inherit px-24 hover:bg-static-default-min-hover", B],
          for: s.for,
          to: A.value
        }, V(m(k))), {
          default: d(() => [
            e.$slots.prefix ? (t(), l("div", {
              key: 0,
              class: r(b)
            }, [
              o(e.$slots, "prefix")
            ], 2)) : a("", !0),
            v("div", {
              class: r(w)
            }, [
              v("span", {
                class: r(L)
              }, [
                o(e.$slots, "label")
              ], 2),
              e.$slots.description ? (t(), l("span", {
                key: 0,
                class: r(I)
              }, [
                o(e.$slots, "description")
              ], 2)) : a("", !0)
            ], 2),
            e.$slots.suffix ? (t(), l("div", {
              key: 1,
              class: r(["self-center", R])
            }, [
              o(e.$slots, "suffix")
            ], 2)) : a("", !0)
          ]),
          _: 2
        }, 1040, ["class", "for", "to"]))
      ]),
      _: 3
    }, 16, ["items-center"]));
  }
});
export {
  G as default
};
